import PropTypes from 'prop-types';
import BrSplitDropdownMenu from '@components/BrSplitDropdownMenu';
import ColorStyles from '@components/ColorStyles';

export default function ActionsDropdownColumn({ row, col }) {
  let displayItems = [];
  const { isReadOnly } = row;

  if (!isReadOnly) {
    displayItems = Object.values(col.columnConfig.optionsList);
  }

  let titleText = col.columnConfig.titleText || 'Manage';
  if (isReadOnly) {
    titleText = 'View';
  }

  const handleOnSelectClick = (value) => {
    col.columnConfig.onButtonClick(row, value);
  };

  const handleOnClick = () => {
    col.columnConfig.onClick(row);
  };

  return (
    <div className="br-table-clickable-actions-column">
      <BrSplitDropdownMenu
        title={titleText}
        className="clickable-action-button"
        useBtnStyle
        btnColorStyle={ColorStyles.BLUE}
        onSelect={handleOnSelectClick}
        onClick={handleOnClick}
        items={displayItems}
      />
    </div>
  );
}

ActionsDropdownColumn.propTypes = {
  row: PropTypes.shape({
    Original_Data: PropTypes.shape({
      id: PropTypes.any,
      name: PropTypes.any,
    }).isRequired,
  }).isRequired,
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      onButtonClick: PropTypes.func.isRequired,
      onClick: PropTypes.func.isRequired, // (row, value:type) :=> {}
      optionsList: PropTypes.any,
      titleText: PropTypes.string,
    }).isRequired,
  }).isRequired,
  cell: PropTypes.shape({
    // cell data
    value: PropTypes.any,
  }).isRequired,
};
